export function present(value) {
  if (!value) {
    return !value
  } else {
    switch(typeof value) {
      case 'string': return !value.match(/\S/)
      case 'object': return 'length' in value ? !value.length : !Object.keys(value).length
      case 'number': return false
      default: throw `Don't know how to validate presence of ${value}`
    }
  }
}

export function email(value) {
  return value && !value.match(/.*@.*\..+/)
}

export function number(value) {
  return value && value.match(/\D/)
}

export function length(amount) {
  return value => value && value.length < amount
}

export function phone(value) {
  if (!value) return
  const numbers = value.replace(/(?:^1|\D)/g, '')
  return numbers.length !== 10
}


// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/validators.js